import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal'
 
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { StartTreatmentComponent } from './components/start-treatment/start-treatment.component';
import { ClinicalExperienceComponent } from './components/clinical-experience/clinical-experience.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';

import { CarouselModule } from 'ngx-owl-carousel-o';
import { SplitedHeaderComponent } from './components/splited-header/splited-header.component';
import { IndexViewComponent } from './views/index-view/index-view.component';
import { AboutViewComponent } from './views/about-view/about-view.component';
import { HalfsContainerComponent } from './components/halfs-container/halfs-container.component';
import { DosagesViewComponent } from './views/dosages-view/dosages-view.component';
import { TreatmentViewComponent } from './views/treatment-view/treatment-view.component';
import { GridAccordionComponent } from './components/grid-accordion/grid-accordion.component';
import { BenefitsComponent } from './views/dosages-sub-views/benefits/benefits.component';
import { FormulaComponent } from './views/dosages-sub-views/formula/formula.component';
import { SpectrumComponent } from './views/dosages-sub-views/spectrum/spectrum.component';
import { ProtocolComponent } from './views/dosages-sub-views/protocol/protocol.component';
import { HttpClientModule } from '@angular/common/http';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { ProtocolsTestimoniesComponent } from './views/protocols-testimonies/protocols-testimonies.component';
import { CoachesComponent } from './views/coaches/coaches.component';
import { TherapistsComponent } from './views/therapists/therapists.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { FaqsViewComponent } from './views/faqs-view/faqs-view.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { AnnouncementsComponent } from './components/announcements/announcements.component';
import { OvercomeDepressionViewComponent } from './views/conversion-view/overcome-depression-view/overcome-depression-view.component';
import { MainNavbarComponent } from './components/navbar/main-navbar/main-navbar.component';
import { HeaderFunnelComponent } from './components/navbar/header-funnel/header-funnel.component';
import { FunnelProtocolComponent } from './views/funnel-views/funnel-protocol-view/funnel-protocol.component';
import { FunnelProtocolsTestimoniesComponent } from './views/funnel-views/funnel-protocols-testimonies /funnel-protocols-testimonies.component';
import { FunnelAboutViewComponent } from './views/funnel-views/funnel-about-view/funnel-about-view.component';
import { TestimoniesModalComponent } from './components/modals/testimonies-modal/testimonies-modal.component';
import { FunnelRebornViewComponent } from './views/funnel-views/funnel-reborn-view/funnel-reborn-view.component';
import { CoachesTestimonialsComponent } from './components/coaches-testimonials/coaches-testimonials.component';
import { MinimalNavbarComponent } from './components/navbar/minimal-navbar/minimal-navbar.component';
import { CoachesFirstContactFormComponent } from './components/forms/funnel/coaches-first-contact-form/coaches-first-contact-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OurApproachComponent } from './views/funnel-views/our-approach/our-approach.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    MainNavbarComponent,
    HeaderFunnelComponent,
    FooterComponent,
    StartTreatmentComponent,
    ClinicalExperienceComponent,
    TestimonialsComponent,
    SplitedHeaderComponent,
    IndexViewComponent,
    AboutViewComponent,
    HalfsContainerComponent,
    DosagesViewComponent,
    TreatmentViewComponent,
    GridAccordionComponent,
    BenefitsComponent,
    FormulaComponent,
    SpectrumComponent,
    ProtocolComponent,
    FunnelProtocolComponent,
    FunnelProtocolsTestimoniesComponent,
    FunnelAboutViewComponent,
    FunnelRebornViewComponent,
    ForbiddenComponent,
    ProtocolsTestimoniesComponent,
    CoachesComponent,
    TherapistsComponent,
    FaqsComponent,
    FaqsViewComponent,
    NotFoundComponent,
    AnnouncementsComponent,
    OvercomeDepressionViewComponent,
    TestimoniesModalComponent,
    CoachesTestimonialsComponent,
    MinimalNavbarComponent,
    CoachesFirstContactFormComponent,
    OurApproachComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgSelectModule,
    AppRoutingModule,
    CarouselModule,
    HttpClientModule,
    ModalModule.forRoot()
  ],
  providers: [
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
